import { render, staticRenderFns } from "./tempPelarasan052013.vue?vue&type=template&id=48038cde&"
import script from "./tempPelarasan052013.vue?vue&type=script&lang=js&"
export * from "./tempPelarasan052013.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports